import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { useSelector } from 'react-redux';
import ProgressBar from '../../common/components/ProgressBar';
import {
  answersFieldsByStepsCatastrophe,
  validationSchemaCommercialCatastrophe,
} from './CommercialCompanyData.validation';
import {
  commercial_catastrophe_tabs,
} from '../../common/constants';
import CommercialCatastropheContractorDeclaration from './Tabs/CommercialCatastropheContractorDeclaration';
import CommercialCatastropheContractorType from './Tabs/CommercialCatastropheContractorType';
import CommercialCatastropheContractorOtherData from './Tabs/CommercialCatastropheContractorOtherData';
import CommercialCatastropheContractorRelations from './Tabs/CommercialCatastropheContractorRelations';
import CommercialCatastropheContractorCoverage from './Tabs/CommercialCatastropheContractorCoverage';
import ContactInfo from './Tabs/ContactInfo';
import PageLoading from '../../common/components/elements/PageLoading';
import { makeQuotationCatastrophe, resetCatastropheObject } from '../../features/commercialReport/commercialReportActions';
import { CommercialQuoteLoading } from '../../common/components/CommercialQuoteLoading';
import { modifyRequestData } from '../../services/axios-client/axeCommons';

function CommercialCompanyCatastrophe() {
  const { vatNumber } = useParams();
  const {
    loading, request_token, isSubmitting, old_request_token,
  } = useSelector(
    (store) => store.commercialReport.catastrophe,
  );

  const [activeTab, setActiveTab] = useState(1);
  const {
    register,
    formState: { errors, touchedFields },
    setValue,
    trigger,
    watch,
  } = useForm({
    mode: 'all',
    resolver: yupResolver(validationSchemaCommercialCatastrophe),
    shouldFocusError: true,
    defaultValues: {
      vat_number: vatNumber,
      sub_product: 'commercial_catastrophe',
      email: '',
      phone: '',
      contractor_declaration: {
        in_good_condition: null, // 1. Il fabbricato è in buone condizioni di statica e manutenzione?
        has_building_violation: null, // 2. Il fabbricato risulta gravato da abuso edilizio?
        under_construction: null, // 3. Il fabbricato è in corso di costruzione, ristrutturazione o ampliamento?
        meets_insurance_requirements: null, // 4. Risponde ai requisiti di assicurabilità?
        matches_insured_data: null, // 4. Risponde ai dati del fabbricato assicurato?
        no_other_policies: null, // 5. Non sono in vigore altre polizze per gli stessi rischi?
        no_canceled_policies: null, // 6. Nessuna polizza annullata nel triennio precedente?
        no_past_damages: null, // 6. Nessun evento dannoso nel triennio precedente?
      },
      type: {
        building_type: null,
        activity_type: null,
      },
      other_data: {
        building_plans: null, // Piani dell'edificio
        construction_year: null, // Anno di costruzione
        construction_typology: null, // Construction typology - vertical load-bearing structures
        occupied_floor: null, // Piani occupati
      },
      coverage: {
        catastrophic_building_coverage: '1',
        catastrophic_building_coverage_value: null,
        catastrophic_content_machinery_coverage: null,
        catastrophic_content_machinery_coverage_value: null,
        catastrophic_content_equipment_coverage: null,
        catastrophic_content_equipment_coverage_value: null,
        catastrophic_land_coverage: null,
        catastrophic_land_coverage_value: null,
      },
      relations: {
        owner_contractor_relation: null, // Rapporto fra proprietario e contraente
      },
    },
  });

  const answers = watch();

  const isValid = (name) => {
    if (errors[name]?.message !== undefined) {
      return false;
    }

    if (touchedFields[name] === undefined) {
      return false;
    }

    return true;
  };

  const nextStep = async () => {
    // check first to be no errors on form
    const res = await trigger(answersFieldsByStepsCatastrophe[activeTab - 1], {
      shouldFocus: true,
    });

    if (res !== true) {
      return;
    }
    if (activeTab === 6) {
      await makeQuotationCatastrophe(answers, request_token);
    } else {
      setActiveTab(activeTab + 1);
      window.scrollTo(0, 0);
    }
  };
  useEffect(() => {
    if (request_token !== null && request_token !== undefined) {
      window.location.href = `/quotes/commercial/${request_token}`;
    }
  }, [request_token]);

  useEffect(() => {
    if (old_request_token !== null && old_request_token !== undefined) {
      const callAsync = async () => {
        const {
          data: { data },
        } = await modifyRequestData(old_request_token);

        if (data) {
          setValue('vat_number', data.vat_number);
          setValue('email', data.email);
          setValue('phone', data.phone);
          setValue('vat_number', data.vat_number);
          setValue('contractor_declaration', JSON.parse(data.contractor_declaration));
          setValue('type', JSON.parse(data.type));
          setValue('other_data', JSON.parse(data.other_data));
          setValue('coverage', JSON.parse(data.coverage));
          setValue('relations', JSON.parse(data.relations));
        }
      };

      callAsync();

      return () => {
        resetCatastropheObject();
      };
    }
    return undefined;
  }, []);

  if (loading && isSubmitting === false) {
    return <PageLoading />;
  }
  return (
    <>
      <div className="d-flex align-items-center justify-content-center gap-3 mt-3 mb-3">
        <div className="row title-questionnaire">
          <div className="quote-h2 divider">
            <h2>Completa I Dati</h2>
          </div>
        </div>
      </div>
      <div className="d-flex align-content-center justify-content-center">
        <ProgressBar
          activeStep={activeTab}
          steps={commercial_catastrophe_tabs}
        />
      </div>
      <div className="card container">
        <div className="card-body">
          <div className="tab-content pt-2">
            {activeTab === 1 && (
              <CommercialCatastropheContractorDeclaration
                errors={errors}
                isValid={isValid}
                register={register}
              />
            )}
            {activeTab === 2 && (
              <CommercialCatastropheContractorType
                errors={errors}
                isValid={isValid}
                register={register}
              />
            )}
            {activeTab === 3 && (
              <CommercialCatastropheContractorOtherData
                errors={errors}
                isValid={isValid}
                register={register}
                answers={answers}
              />
            )}
            {activeTab === 4 && (
              <CommercialCatastropheContractorCoverage
                errors={errors}
                isValid={isValid}
                register={register}
                answers={answers}
              />
            )}
            {activeTab === 5 && (
              <CommercialCatastropheContractorRelations
                errors={errors}
                isValid={isValid}
                register={register}
              />
            )}
            {activeTab === 6 && (
              <ContactInfo
                errors={errors}
                isValid={isValid}
                register={register}
              />
            )}
          </div>
        </div>
      </div>

      <div className="footer-buttons">
        <div className="d-flex justify-content-between">
          {activeTab > 1 && (
            <button
              className="btn btn-questionnaire"
              onClick={() => {
                setActiveTab(activeTab - 1);
                window.scrollTo(0, 0);
              }}
            >
              Back
            </button>
          )}
          <button className="btn btn-questionnaire" onClick={nextStep}>
            Continua
          </button>
        </div>
      </div>
      {isSubmitting === true && <CommercialQuoteLoading />}
    </>
  );
}

export default CommercialCompanyCatastrophe;
